import router from './router'
// import Mock from '@/mock'
const _import = require('./router/_import_' + process.env.NODE_ENV)//获取组件的方法
import Layout from '@/components/Home' //views 是架构组件，不在后台返回，在文件里单独引入
import Login from '@/components/Login'
import Wellcome from '@/components/Wellcome'
// http://127.0.0.1:8000/rest/console/test
import '@/utils/global' // 全局


var thisRouter //用来获取后台拿到的路由
router.beforeEach((to, from, next) => {
  //console.log('before each')
  //window.localStorage.clear() //测试每次请求菜单

  if (!thisRouter) { //不加这个判断，路由会陷入死循环
    //console.log('enter if')
    if (!getObjArr('router')) {
      /*
      axios.get('https://www.easy-mock.com/mock/5a5da330d9b48c260cb42ca8/example/antrouter').then(res => {
        thisRouter = res.data.data.router//后台拿到路由
        saveObjArr('router', thisRouter) //存储路由到localStorage

        routerGo(to, next)//执行路由跳转方法
      })*/

      var postData = {
        'id': "all"
      }
      //console.log('success')
      //console.log(postData)

      var vsuccess = function(rspdata){
          //console.log('ajax reqeust success')

          var vrouters = []
          //var rspdata = rsp.data
          // console.log("======get navi data ======")
          // console.log(rsp.data)
          // 添加动态路由
          if (rspdata.code === 0) {
            //{ path: '/', redirect: '/home' },
            vrouters.push({
              path: '/',
              redirect: '/login'
            })
            // { path: '/login',component:Login, meta:{title:'登录'}},
            vrouters.push({
              path: '/login',
              hidden: true,
              component: Login,
              name: global.capitalize('login'),
              meta: {
                title: '登录'
              }
            })
            //三栏页面
            var vparent = {
              path: '/home',
              component: Layout,
              name: global.capitalize('home'),
              redirect: '/wellcome',
              meta: {
                title: '控制台',
                icon: 'fa-default'
              },
              children: [] //字路由为空
            }

            var child = {
              path: '/wellcome',
              show: true,
              component: Wellcome,
              name: global.capitalize('wellcome'),
              meta: {
                title: '控制台',
                icon: 'fa-default'
              }
            }
            vparent.children.push(child)
            var vpath = '@/layout'

            var isparent = true
            rspdata.data.forEach((item) => { //遍历动态路由表
               if(item.parent > 0) //所有的页面路由
               {
              child = {
                'path': '/' + item.path, //务必在前加路径符号,路由的依据
                'show': true,
                'component': item.path,
                'name': global.capitalize(item.path.replace('/','')),
                'meta': {
                  'title': item.text,
                  'icon': item.icon
                }
              }
              vparent.children.push(child)
              }

            })
            //foreadh
            //全部添加到路由中
            vrouters.push(vparent)
          } //endif
          //vrouters.splice(rspdata.count,1)
          //console.log(vrouters)
          thisRouter = vrouters //后台拿到路由
          saveObjArr('router', thisRouter) //存储路由到localStorage
          routerGo(to, next) //执行路由跳转方法

      }
      var vfail = function(rsp){}
      global.http('/console/navigator',postData,vsuccess,vfail)


    } else { //从localStorage拿到了路由
      thisRouter = getObjArr('router') //拿到路由
      routerGo(to, next)
    }
  } else {
    //console.log("enter next")
    next()
  }

})


function routerGo(to, next) {
  thisRouter = filterAsyncRouter(thisRouter) //过滤路由
  router.addRoutes(thisRouter) //动态添加路由
  global.antRouter = thisRouter //将路由数据传递给全局变量，做侧边栏菜单渲染工作
  next({
    ...to,
    replace: true
  })
}

function saveObjArr(name, data) { //localStorage 存储数组对象的方法
  localStorage.setItem(name, JSON.stringify(data))
}

function getObjArr(name) { //localStorage 获取数组对象的方法
  return JSON.parse(window.localStorage.getItem(name));

}

function filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象

  const accessedRouters = asyncRouterMap.filter(route => {
    //console.log(route)
    if (route.component) {
      if (route.component === 'Layout') { //Layout组件特殊处理,为根据目录
        route.component = Layout
      } else {
        if (route.component.length != undefined) {
          // ()=>import('@/views/Test1.vue')
          // ()=>import('@/views/buisness_model/Test1.vue')
          //route.component =()=>{} _import(route.component)
          //大小写敏感，在数据库即处理好，与组件文件名对应（一般是大驼峰）
          route.component = _import(route.component)   //从views路径出发  如果是下级需要将路径带上

          //route.component = () => import(route.component + '.vue')
          //console.log('======================')
          //console.log(route.component)
        }

      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })

  return accessedRouters

}



// WEBPACK FOOTER //
// ./src/promission.js